"use client";

import { lazy, Suspense } from "react";

const MobileHeader = lazy(() =>
  import("./mobile-header.component").then((m) => ({
    default: m.MobileHeader,
  })),
);
const MobileMenuOverlay = lazy(() =>
  import("./mobile-menu-overlay.component").then((m) => ({
    default: m.MobileMenuOverlay,
  })),
);

function MobileNavbarSkeleton() {
  return <div className="h-16 desktop-lg:hidden" />;
}

export function MobileNavbarLazy() {
  return (
    <Suspense fallback={<MobileNavbarSkeleton />}>
      <MobileHeader />
      <MobileMenuOverlay />
    </Suspense>
  );
}
